<template>
    <b-modal id="order_delete" ref="order_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.order.data.attributes.item + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('order_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteOrder">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "OrderDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'order'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteOrder() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteOrder', this.order)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-order');

                            this.$notify('error filled', 'Success!', 'Deleted the order!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('order_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
